import { Typography } from '@mui/material';
import { Card } from '@/features/card';
import { LocationSelector } from '@/features/location';
import { MapType } from '@/features/map';
import { useProfileQuery } from '@/models/user';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
// import { Summaries } from '@/pages/main/Summaries';

const DEFAULT_AREA_ID = 3;
const DEFAULT_COUNTRY_ID = 1;

export const Main = () => {
  const { data } = useProfileQuery();
  const { t } = useTranslation();
  const [areaId, setAreaId] = useState<number | undefined>(DEFAULT_AREA_ID);
  const [countryId, setCountryId] = useState<number | undefined>(
    DEFAULT_COUNTRY_ID
  );
  const companyName = data?.companyName;

  return (
    <div className="flex flex-col w-full">
      {companyName && (
        <div className="mb-4">
          <Typography variant="h4" fontWeight={500}>
            {t('label.welcome')} {companyName}
          </Typography>
        </div>
      )}

      {/* <div className="flex gap-4 mb-4"><Summaries /></div> */}

      <div className="flex gap-4">
        <div className="flex-1 basis-3/4">
          <LocationSelector
            areaId={areaId}
            countryId={countryId}
            mapType={MapType.WithDevices}
            onChangeArea={(id?: number) => {
              setAreaId(id);
            }}
            onChangeCountry={(id?: number) => {
              setCountryId(id);
              setAreaId(undefined);
            }}
          />
        </div>
        <div className="flex-1 basis-1/4">
          <Typography variant="h6" sx={{ mb: '16px' }}>
            {t('label.updates')}
          </Typography>
          <Card>
            <div className="flex flex-col h-full">
              <div className="w-full h-full flex items-center justify-center">
                <Trans i18nKey="label.available_soon" />
              </div>
              <div className="grow-0 bg-black"></div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};
